const ButtonWrap = ({ contents, onClick, isDisabled = false }) => (
    <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        className="font-semibold py-2 px-4 border hover:border-transparent rounded disabled:opacity-25 bg-transparent hover:bg-gray-800 text-gray-700 hover:text-white border-gray-300"
    >{contents}</button>
)

export default ButtonWrap;